<button 
    [pTooltip]=" artworkFiles.length > 1 && disabled ? 'Please name all images before continuing.' : ''"
    tooltipPosition="top" 
    placeholder="Top"
    [disabled]="disabled || onSubmit"
    (click)="submitArtworks()"
    class="btn btn-primary ml20">
    {{onSubmit ? 'Uploading...' : artworkFiles.length > 1 ? 'Upload and Continue': 'Implement' }}
</button>
